import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionBancosDocumentoComponent {
  idCliente
  idCuenta
  idDocumento
  archivo = undefined
  type = 'application/pdf'
  onChange

  constructor ($api, $fileSystem, ClienteInformacionBancosDocumento) {
    this.$api = $api
    this.$fileSystem = $fileSystem
    this.ClienteInformacionBancosDocumentoService = ClienteInformacionBancosDocumento
  }

  $onInit () {
    this.promise = this.idDocumento ? this.ClienteInformacionBancosDocumentoService.get(this.idCliente, this.idCuenta, this.idDocumento)
      .then(({data}) => (this.nombre = data.nombre)) : angular.noop()
  }

  selecionar () {
    this.$fileSystem.select(false, this.type)
      .then((files) => {
        this.archivo = files[0]
        this.agregar()
      }).catch(() => {
      console.info('fallo el cargar el archivo')
    })
  }

  agregar () {
    this.ClienteInformacionBancosDocumentoService.post(this.idCliente, this.idCuenta, this.archivo)
      .then(({data}) => {
        this.nombre = data.nombre
        this.idDocumento = data.idDocumento
      })
  }

  abrir () {
    this.url = this.$api.link('/api/clientes/cliente/informacion/bancos/documento/pdf', {
      idCliente: this.idCliente,
      idCuenta: this.idCuenta,
      idDocumento: this.idDocumento,
    })

    window.open(this.url, '_blank')
  }

  eliminar(){
    this.idDocumento = null
    this.onChange()
  }
}

module.component('clienteInformacionBancosDocumento', {
  controller: ClienteInformacionBancosDocumentoComponent,
  template,
  bindings: {
    idCliente: '<',
    idCuenta: '<',
    idDocumento: '<',
    onChange:'&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/bancos/documento/component.js